import { trigger, state, style, transition, animate } from '@angular/animations';

export const accordionSlide = trigger('accordionBody', [
	state(
		'collapsed',
		style({
			height: '0px',
			paddingBottom: '0px',
			opacity: 0,
		}),
	),
	state(
		'expanded',
		style({
			height: '*',
			padding: '*',
			opacity: 1,
		}),
	),
	transition('collapsed <=> expanded', animate('200ms ease')),
]);
